<template>
    <div class="n2-container">
        <div class="n2-nav-back">
            <a @click="$router.go(-1)" class="n2-link-back">
                <div style="display: flex; align-items:center;">
                    <i aria-hidden="true" class="fa fa-angle-left" style="font-size:2em;"></i>
                    <span style="margin-left:5px;">
                        {{ $t('pages.admin.claims.back') }}
                    </span>
                </div>
            </a>
        </div>
        <div class="n2-page-title">
            <h3>{{ $t('pages.admin.claims.title') }}</h3>
        </div>
        <p>
            <label class="n2-link-1" v-on:click="openNewClaimModal()">
                {{ $t('pages.admin.claims.create') }}
            </label>
        </p>
        <div style="position:relative;">
            <div v-if="entities.length > 0" class="n2-claims">
                <ul>
                    <li v-for="(entity) in entities" v-bind:key="entity.id">
                        <label v-on:click="selectEntity(entity)">{{ entity.claim_type }}&nbsp;&nbsp; - &nbsp;&nbsp;{{ entity.claim_value }}</label>
                        <ul>
                            <li v-for="child in entity.claims" v-bind:key="child.id">
                                <label v-on:click="selectEntity(child)">{{ child.claim_value }}</label>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div v-else class="title-default">
                {{ $t('shared.pager.no_record') }}
            </div>
        </div>
        <app-loader v-bind:active="loading"></app-loader>
        <div id="n3-claim-modal" class="w3-modal">
            <div class="w3-modal-content w3-card-4" style="max-width:600px;position:relative;">
                <span v-on:click="closeModal" style="position:absolute; right:0;" class="n2-close n2-close-40"></span>
                <div class="w3-container" style="padding-bottom: 16px;">
                    <h4 class="n2-text-center">
                        <template v-if="entity.id">
                            {{ $t('pages.admin.claims.claim') }}
                        </template>
                        <template v-else>
                            {{ $t('pages.admin.claims.new_claim') }}
                        </template>
                    </h4>
                    <h5 v-if="entity.parent_claim_value">
                        {{ $t('pages.admin.claims.create_child_claim_for') }}: {{ entity.parent_claim_value }}
                    </h5>
                    <p v-if="entity.parent_claim_id == null && entity.id">
                        <label class="n2-link-1" v-on:click="openNewClaimModal(entity.id, entity.claim_value)">
                            {{ $t('pages.admin.claims.create_child_claim') }}
                        </label>
                    </p>
                    <div class="n2-row-padding">
                        <div class="col-md-12">
                            <div class="n2-panel-default">
                                <form-input type="select" v-model="entity.claim_type"
                                    v-bind:label="$t('pages.admin.claims.claim_type')">
                                    <template v-slot:options>
                                        <option value=""></option>
                                        <option v-for="claim_type in claim_types" v-bind:key="claim_type"
                                            v-bind:value="claim_type">{{ claim_type }}</option>
                                    </template>
                                </form-input>
                                <form-input type="text" v-model="entity.claim_value"
                                    v-bind:label="$t('pages.admin.claims.claim_value')"
                                    v-bind:errors="model_errors.claim_value"></form-input>

                            </div>


                            <validation-summary v-bind:errors="model_errors"></validation-summary>

                            <div class="n2-form-group">
                                <div v-if="entity.id" class="n2-display-flex n2-justify-content-space-between">
                                    <span class="n2-button-1 n2-button-delete"
                                        onclick="document.getElementById('n1-delete-modal').style.display='block'">{{
                                            $t('pages.admin.claims.delete') }}</span>
                                    <button class="n2-button-1" v-on:click="update">
                                        {{ $t('pages.admin.claims.save') }}
                                    </button>
                                </div>
                                <div v-else class="n2-text-right">
                                    <button v-on:click="create" class="n2-button-1">
                                        {{ $t('pages.admin.claims.create') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <app-loader v-bind:active="change_vehicle_loading"></app-loader>

            </div>




        </div>
        <!--delete---------------------------------->
        <div id="n1-delete-modal" class="w3-modal">
            <div class="w3-modal-content w3-card-4" style="max-width:600px">
                <div class="w3-center">
                    <br>
                    <span v-on:click="closeModal" class="w3-button w3-xlarge w3-hover-red w3-display-topright"
                        title="Close Modal">&times;</span>
                    <label class="n2-form-label">{{ $t('pages.admin.claims.confirm_delete')
                        }}</label>
                </div>
                <div class="w3-container w3-padding-16">
                    <button type="button" class="n2-button-1 n2-button-delete n2-right" v-on:click="deleteEntity()">{{
                        $t('pages.admin.claims.delete') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { debounce } from '../shared';
import { ClaimService } from '../services';
import AppLoader from '../components/shared/loader.vue'
import FormInput from "../components/shared/form-input.vue"
import { settings } from '../settings';

export default {
    components: {
        AppLoader, FormInput
    },
    props: {
    },
    data: function () {
        return {
            query: {
                page_size: 100,
                page_number: 1,
                sort_by: '',
                sort_direction: '',
                claim_value: '',
            },
            total_size: 0,
            sortings: {
                claim_value: 0
            },
            entities: [],
            error: '',
            loading: false,
            entity: {},
            model_errors: {},
            claim_types: []
        }
    },
    computed: {
        ...mapGetters('globalization', [
            'locale', 'app_locale'
        ]),
        grid_columns_length: function () {
            let len = this.columns.length + 1;
            return len;
        },
        grid_columns: function () {
            return new Array(this.grid_columns_length).join('auto ');
        },
    },
    watch: {
        // whenever question changes, this function will run
        'query.claim_value': function () {
            this.debouncedSearch();
        },
        'query.sort_by': function () {
            this.debouncedSearch();
        },
        'query.sort_direction': function () {
            this.debouncedSearch();
        }
    },
    created: function () {
        this.currentService = new ClaimService();
        this.debouncedSearch = debounce(this.nav, 500);
    },
    mounted: async function () {
        this.claim_types = settings.claim_types;
        Object.assign(this.query, this.$route.query);
        await this.search();
    },
    beforeRouteUpdate(to, from, next) {
        Object.assign(this.query, to.query);
        this.search();
        next();
    },
    methods: {
        sort: function (field) {
            this.sortings[field] = (this.sortings[field] + 1) % 3;
            this.query.sort_by = this.sortings[field] === 0 ? '' : field;
            this.query.sort_direction = this.sortings[field] === 0 ? '' : this.sortings[field] === 1 ? 'asc' : 'desc';
            Object.keys(this.sortings).filter(k => { return k !== field; }).forEach(k => this.sortings[k] = 0);
        },
        search: async function () {
            this.loading = true;
            try {
                var response = await this.currentService.search(this.query);
                this.entities = response.data;
                this.total_size = response.total_size;
                this.query.page_size = response.page_size;
                this.query.page_number = response.page_number;
            } catch (e) {
                this.error = e;
            }
            finally {
                this.loading = false;
            }
        },
        nav: function () {
            this.$router.push({
                path: '', query: this.query
            });
        },
        navToPage: function (page_number) {
            this.query.page_number = page_number;
            this.nav();
        },
        openModal: function (id) {
            this.modal_error = '';
            document.getElementById(id).style.display = 'block';
        },
        openNewClaimModal: function (parent_id, parent_claim_value) {
            this.entity = {};
            if (parent_id) {
                this.entity.parent_claim_value = parent_claim_value;
                this.entity.parent_claim_id = parent_id;
            }
            this.openModal('n3-claim-modal');
        },
        closeModal: function () {
            var x = document.getElementsByClassName("w3-modal");
            var i;
            for (i = 0; i < x.length; i++) {
                x[i].style.display = "none";
            }
        },
        selectEntity: function (entity) {
            this.entity = entity;
            this.openModal('n3-claim-modal');
        },
        validateForm: function () {
            this.model_errors = {}
            if (!this.entity.claim_value) {
                this.model_errors['claim_value'] = [this.$t('pages.admin.claims.error_claim_value')]
            }


            //////////////////
            if (Object.keys(this.model_errors).length > 0) {
                return false
            }
            else {
                return true
            }
        },
        create: async function () {
            if (!this.validateForm()) {
                return false;
            }
            try {
                await this.currentService.create(this.entity);
                await this.search();
                this.closeModal();
            }
            catch (err) {
                this.$set(this.model_errors, 'error', ['Error']);
            }
        },
        update: async function () {
            if (!this.validateForm()) {
                return false;
            }
            try {
                await this.currentService.update(this.entity.id, this.entity);
                this.closeModal();
            }
            catch (err) {
                this.$set(this.model_errors, 'error', ['Error']);
            }
        },
        deleteEntity: async function () {
            try {
                await this.currentService.delete(this.entity.id);
                await this.search();
                this.closeModal();
            }
            catch (err) {
                if (err.response) {
                    this.model_errors = err.response.data;
                }
            }
        },
    },

}
</script>